import { useEffect, useRef } from "react";
import { Box, Text, Switch } from "@flexisaf/flexibull2";
import styled from "styled-components";
import Theme from "../../theme";
import useAudioUploader from "../../hooks/audio/useAudioUploader";
import { selectCurrentSection } from "../../redux/section/selectors";
import { useSelector } from "react-redux";
import useAudioGet from "../../hooks/audio/useAudioGet";

function AudioUploader({ selectedFile, setSelectedFile }) {
  const fileInputRef = useRef();
  const section = useSelector(selectCurrentSection);

  const { audio, loadingAudio, setAudio } = useAudioGet({
    id: section?.multimediaFile?.id,
  });

  useEffect(() => {
    if (audio?.audioUrl !== "") {
      setSelectedFile({
        file: null,
        id: audio?.audioId,
        internalUrl: audio?.audioUrl || null,
      });
    }
  }, [audio, setSelectedFile]);

  const handleFileChange = (event) => {
    const file = event.target.files[0];
    setSelectedFile({
      file: file,
      internalUrl: URL.createObjectURL(file),
      listenOnce: true,
      upload: true,
      id: null,
    });
  };

  const handleDragOver = (event) => {
    event.preventDefault();
  };
  const handleDrop = (event) => {
    event.preventDefault();
    const file = event.target.files[0];
    setSelectedFile({
      file: file,
      internalUrl: URL.createObjectURL(file),
      listenOnce: true,
      upload: true,
      id: null,
    });
  };
  const { deleteAudio } = useAudioUploader();

  function CloseAudio() {
    fileInputRef.current.value = "";
    setSelectedFile({ file: null, id: null, listenOnce: true });
    setAudio({ audioUrl: "", audioId: "" });
    return;
  }
  function handleDeleteAudio() {
    if (audio.audioId !== "" && selectedFile) {
      deleteAudio({ id: audio?.audioId });
      fileInputRef.current.value = "";
      setSelectedFile({ file: null, id: null, listenOnce: true });
      setAudio({ audioUrl: "", audioId: "" });
      return;
    }
    return;
  }
  return (
    <AudioContainer>
      <Box
        style={{ opacity: selectedFile.internalUrl ? 0.5 : 1 }}
        onDragOver={handleDragOver}
        onDrop={handleDrop}
        className="uploads "
      >
        {loadingAudio ? (
          <Box>
            <Text color={Theme.PrimaryGrey}>Loading...</Text>
          </Box>
        ) : (
          <Box>
            <p>
              {" "}
              <i className="saf-document-upload" style={{ fontSize: "19px" }} />
            </p>
            <p>
              Drag and drop your or <label htmlFor="audio">Choose file</label>{" "}
              to upload.
            </p>
            <Text color={Theme.PrimaryGrey}>WAV or MP3</Text>
            <input
              id="audio"
              type="file"
              ref={fileInputRef}
              accept="audio/*"
              onChange={handleFileChange}
              style={{ display: "none" }}
              disabled={selectedFile.internalUrl ? true : false}
            />
          </Box>
        )}
      </Box>
      {selectedFile?.internalUrl && (
        <div>
          <Box className="file">
            <p>
              <i className="saf-audio-square" style={{ fontSize: "19px" }} />{" "}
              {selectedFile?.file ? selectedFile?.file.name : selectedFile?.id}
            </p>
            <p
              className="close"
              onClick={audio.audioId ? handleDeleteAudio : CloseAudio}
            >
              <i className="saf-close-circle" style={{ fontSize: "19px" }} />{" "}
            </p>
          </Box>
          <audio controls>
            <source src={selectedFile?.internalUrl} type="audio/mpeg" />
            Your browser does not support the audio element.
          </audio>
          <hr />
          <Box className="advanceSetting">
            <h3>Advanced Settings</h3>
            <div>
              <p>
                <Text
                  bold
                  size={Theme.H2}
                  block={!false}
                  style={{ paddingBottom: "10px" }}
                >
                  Single Listen
                </Text>
                <Text color={Theme.PrimaryGrey}>
                  if active, the user will only be able to listen to the audio
                  once <br /> for the duration of the practice
                </Text>
              </p>
              <div>
                <Switch
                  checked={selectedFile?.listenOnce}
                  onChange={(e) =>
                    setSelectedFile((prev) => {
                      return {
                        ...prev,
                        listenOnce: e.target.checked ? true : false,
                      };
                    })
                  }
                />
              </div>
            </div>
          </Box>
        </div>
      )}
    </AudioContainer>
  );
}

export default AudioUploader;

const AudioContainer = styled.div`
  padding: 20px;
  .uploads div {
    border: 2px dashed #ccc;
    padding: 20px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    border-radius: 10px;
    height: 200px;
    label {
      cursor: pointer;
      color: blue;
    }
  }

  hr {
    border: 1px solid #ccc;
    margin: 25px 0px;
  }

  .file {
    background: #f2f4f5;
    padding: 6px 20px;
    margin: 10px auto;
    border-radius: 10px;
    display: flex;
    justify-content: space-between;
  }
  .close {
    cursor: pointer;
  }
  .advanceSetting {
    div {
      display: flex;
      justify-content: space-between;
      align-items: center;
      background: #f2f4f5;
      padding: 10px 20px;
      /* margin: 10px auto; */
      border-radius: 10px;
    }
  }
`;
